import * as React from 'react';

import { ConfirmationDialog } from './components/ConfirmationDialog';
import {
  ConfirmDialogCallback,
  useDialogsProvider,
} from './useDialogsProvider';

export interface DialogsProviderProps {
  children: React.ReactNode;
}

const contextInitialValue: ConfirmDialogCallback = (
  _description: string | React.ReactNode,
  _handleClose: (confirmed: boolean) => void,
) => {};
export const Context =
  React.createContext<ConfirmDialogCallback>(contextInitialValue);

export const DialogsProvider: React.FC<DialogsProviderProps> = ({
  children,
}) => {
  const { setConfirmationDialogSettingsRef, confirm } = useDialogsProvider();

  return (
    <Context.Provider value={confirm}>
      {children}
      <ConfirmationDialog
        setConfirmationDialogSettingsRef={setConfirmationDialogSettingsRef}
      />
    </Context.Provider>
  );
};
